import { render, staticRenderFns } from "./LandingComoCardsItem.vue?vue&type=template&id=b1978e52&scoped=true"
import script from "./LandingComoCardsItem.vue?vue&type=script&lang=js"
export * from "./LandingComoCardsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1978e52",
  null
  
)

export default component.exports